import ComponentSupport from './component-support'
import {version} from './version';

let Config = require('./config.dev-manual.json');

switch (process.env.NODE_ENV) {
    case 'staging':
        console.log('Config: ./config.staging.json');

        Config = require('./config.staging.json');

        break;
    case 'production':
        console.log('Config: ./config.prod.json');

        Config = require('./config.prod.json');

        break;
    default:
        console.log('Config: ./config.dev-manual.json');
}

Config.componentSupport = ComponentSupport;
Config.version = version + ' ' + Config.configName;
Config.versionRaw = version;
Config.componentTransition = 'fade';

export default Config